import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import './ChangePasswordStyle.css'; // CSS-Datei importieren

interface Errors {
    oldPassword?: string;
    newPassword?: string;
    confirmPassword?: string;
  }

  interface Props{
    login: String;
}

function ChangePasswordPage({login}:Props){ 
    const [oldPassword, setOldPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [errors, setErrors] = useState<Errors>({});
    const [passwordState, setPasswordState] = useState<string>('');
    const [showPopup, setShowPopup] = useState(false);
    const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
    const [newPasswordVisible, setNewPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const navigate = useNavigate();

    const handlePasswordChange = async () => {
        const valid = await validPasswordChange()
        if(valid){
            //Change password
            const change = await ChangePassword(login,newPassword)
            if(change){
                setPasswordState('Passwort wurde erfolgreich geändert')
            } else {
                setPasswordState('Passwort konnte nicht geändert werden, bitte versuchen Sie es später noch einmal')
            }
            setShowPopup(true)
        }
    }

    const ChangePassword = async(login:String,password:string) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ChangePassword.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            login,
            password
          }),
        });
      
        if (response.ok) {
          const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          //console.log('Erfolgreich eingeloggt:', data);
          //console.log('tag:', data['tag']);
          console.log(data);
          const answer = data['message'];
          console.log(answer);
          if(answer === 'Update erfolgreich' ){
            //Passwort ok
            return true
          }
          else {
            //Passwort falsch
            return false
          }
        } else {
          const data = await response.json();
          //console.log(data);
          console.error('Fehler beim Einloggen:', response.statusText);
          return false
        }
      } catch (error) {
        console.error('Fehler beim Einloggen:', error);
        return false
      }
    }

    const CheckExistSQLEntrie = async(login:String,password:string) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/PasswordChecker.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            login,
            password
          }),
        });
      
        if (response.ok) {
          const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          //console.log('Erfolgreich eingeloggt:', data);
          //console.log('tag:', data['tag']);
          const answer = data['message'];
          console.log(answer);
          if(answer === 'OK' ){
            //Passwort ok
            return true
          }
          else {
            //Passwort falsch
            return false
          }
        } else {
          const data = await response.json();
          //console.log(data);
          console.error('Fehler beim Einloggen:', response.statusText);
          return false
        }
      } catch (error) {
        console.error('Fehler beim Einloggen:', error);
        return false
      }
    }

    const handlePopUp = () => {
        setShowPopup(false)
        navigate("/")
    }

    const validPasswordChange = async (): Promise<boolean> =>{
        // Zurücksetzen der Fehlermeldung
        const newErrors: Errors = {};

        // Überprüfen, ob alle Felder ausgefüllt sind
        if (!oldPassword) {
            newErrors.oldPassword = "Bitte altes Passwort eingeben"
        }

        const exists = await CheckExistSQLEntrie(login,oldPassword);
        if (!exists) {
          newErrors.oldPassword = "Altes Passwort falsch"
        }

        // Überprüfen, ob das neue Passwort mindestens 8 Zeichen lang ist
        if (newPassword.length < 8) {
            newErrors.newPassword = 'Das neue Passwort muss mindestens 8 Zeichen lang sein.'
        }
        if (!newPassword) {
            newErrors.newPassword = "Bitte neues Passwort eingeben"
        }

        // Überprüfen, ob das neue Passwort mit dem Bestätigungspasswort übereinstimmt
        if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = 'Die neuen Passwörter stimmen nicht überein.'
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = "Bitte neues Passwort bestätigen"
        }

        setErrors(newErrors);
        // Wenn keine Fehler gefunden wurden, ist das Formular valide
        return Object.keys(newErrors).length === 0;
    };

    const toggleOldPasswordVisibility = () => {
        setOldPasswordVisible(!oldPasswordVisible);
    };

    const toggleNewPasswordVisibility = () => {
        setNewPasswordVisible(!newPasswordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    return (
        <div className="mainContainer">
            <div className="titleContainer">
                <h2>RescueOfficer Passwort ändern</h2>
            </div>

            <div className={"inputContainer"}>
                <label>Altes Passwort:</label>
                <div className="passwordContainer">
                    <input
                    className='inputBox'
                    placeholder='Altes Passwort'
                    type={oldPasswordVisible ? "text" : "password"}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    />
                    <FontAwesomeIcon
                        icon={oldPasswordVisible ? faEyeSlash : faEye}
                        onClick={toggleOldPasswordVisibility}
                        className="passwordIcon"
                    />
                </div>
                <label className="errorLabel">{errors.oldPassword}</label>
            </div>
            <br></br>

            <div className={"inputContainer"}>
                <label>Neues Passwort:</label>
                <div className="passwordContainer">
                    <input
                    className='inputBox'
                    placeholder='Neues Passwort'
                    type={newPasswordVisible ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <FontAwesomeIcon
                        icon={newPasswordVisible ? faEyeSlash : faEye}
                        onClick={toggleNewPasswordVisibility}
                        className="passwordIcon"
                    />
                </div>
                <label className="errorLabel">{errors.newPassword}</label>
            </div>
            <br></br>

            <div className={"inputContainer"}>
                <label>Neues Passwort bestätigen:</label>
                <div className="passwordContainer">
                    <input
                    className='inputBox'
                    placeholder='Neues Passwort bestätigen'
                    type={confirmPasswordVisible ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <FontAwesomeIcon
                        icon={confirmPasswordVisible ? faEyeSlash : faEye}
                        onClick={toggleConfirmPasswordVisibility}
                        className="passwordIcon"
                    />
                </div>
                <label className="errorLabel">{errors.confirmPassword}</label>
            </div>
            <br></br>
            <br></br>



    
                <div className="inputContainer">
                <input
                    className="inputButton"
                    type="button"
                    onClick={handlePasswordChange}
                    value={"Passwort ändern"} />
                </div>


                {showPopup && ( // Pop-up Bedingung
                <div className="popup">
                    <div className="popupContent">
                        <p>{passwordState}</p>
                        <div className="inputContainer">
                            <input
                                className="inputButton"
                                type="button"
                                onClick={handlePopUp}
                                value={"Schließen"} />
                        </div>
                    </div>
                </div>
                 )}
        </div>

        
    );
};

export default ChangePasswordPage;